/* eslint-disable class-methods-use-this */
import {UIMSceneEnum} from '../../../../shared/enums/UIMSceneEnums.ts'
import {SocketLobbySend} from '../../../shared/scripts/socket/SocketLobbySend.ts'
import {UIManagerEvents} from '../../../shared/scripts/ui_html/UIManagerEvents.ts'
import {type UIMManager} from './UIMManager.ts'
import {UIUrlParameterNames} from '../../../shared/scripts/ui_html/UIUrlController.ts'
import {EntryMobileUrlParameterController} from '../EntryMobileUrlParameterController.ts'
import {getHomepageUrlWithParameter, navigateToPage} from '../../../shared/scripts/ui_utils/ClientUtils.ts'
import {UIPopupManager} from '../../../shared/scripts/ui_popup/UIPopupManager.ts'
import {MobileWebviewCommunicationActions} from '@colonist/mobile'
import {UIMMobileWebviewCommunication} from '../ui_mobile_communication/UIMMobileWebviewCommunication.ts'
import {UIDeviceController} from '../../../shared/scripts/ui_html/UIDeviceController.ts'

export class UIMManagerEvents extends UIManagerEvents {
    private readonly uiManager: UIMManager

    constructor(uiManager: UIMManager) {
        super()
        this.uiManager = uiManager
    }

    async createClickedJoinRoomCallback(gameId: string) {
        await SocketLobbySend.clickedJoinRoom(gameId)
    }

    isSceneLobby(): boolean {
        return this.uiManager.sceneController.scene != UIMSceneEnum.Lobby
    }

    isSceneGame(): boolean {
        return this.uiManager.sceneController.scene == UIMSceneEnum.Game
    }

    leaveRoomAndJoinRoom(roomId: string) {
        void SocketLobbySend.clickedJoinRoom(roomId)
    }

    handleUrlRedirectViaParameters(parameter: UIUrlParameterNames, parameterValue: any) {
        UIPopupManager.closeAllPopups()

        if(parameter == UIUrlParameterNames.EnterMatchmaking) {
            void EntryMobileUrlParameterController.loadMatchmakingQueue(parameterValue)
            return
        }

        if(parameter == UIUrlParameterNames.Spectate) {
            navigateToPage(getHomepageUrlWithParameter(parameter, parameterValue))
            return
        }
    }

    premiumMembershipCheckAction() {
        return () => {
            navigateToPage('/store#membership', true, true)
        }
    }

    shareImage(title: string, text: string, link: string, imageFile: File, imageSrc: string) {
        if(UIDeviceController.isUserOnMobileOrTabletWebBrowser()) {
            void navigator.share({
                title: title,
                text: text,
                url: link,
                files: [imageFile],
            })
            return
        }

        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShareImage, {
            title: title,
            imageSrc: imageSrc,
        })
    }
}
